var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"faq-item",class:{ active: _vm.active },on:{"click":_vm.toggle}},[_c('section',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.category))]),_c('app-icon',{attrs:{"name":"angle-down"}})],1),_c('section',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }